import { Button, Message, Modal } from 'semantic-ui-react';

export const DeleteRoadblockModal = ({ open, roadblockId, deleting, error, onClose, onConfirm }) => (
    <Modal open={open} onClose={onClose} size="tiny">
        <Modal.Header>Delete Roadblock #{roadblockId}</Modal.Header>
        <Modal.Content>
            <p>
                Are you sure you want to permanently delete this roadblock?
                <br />
                <strong>All attached notes will also be deleted and cannot be recovered.</strong>
            </p>
            {error && <Message negative size="small">{error}</Message>}
        </Modal.Content>
        <Modal.Actions>
            <Button type="button" onClick={onClose} disabled={deleting}>
                Cancel
            </Button>
            <Button
                negative
                type="button"
                onClick={onConfirm}
                loading={deleting}
                disabled={deleting}
            >
                Delete
            </Button>
        </Modal.Actions>
    </Modal>
);
